export enum ProviderSearchTypes {
    'docNumber' = 'docNumber',
    'id' = 'id',
    'companyOrTradingName' = 'companyOrTradingName',
    'cityName' = 'cityName',
    'state' = 'state',
}
